import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78b4e410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = {
  key: 0,
  class: "custom-main"
}
const _hoisted_3 = { class: "textLink" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "联系方式", -1))
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin":"15px 0 20px 0"} }
const _hoisted_7 = { style: {"width":"300px","font-size":"14px","color":"#333333","line-height":"30px"} }
const _hoisted_8 = { class: "custom-footer" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "icon icon-customPhone",
      title: "获取联系方式",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
    }),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("i", {
              class: "icon icon-close btn-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.mynickname) + "希望获取您的联系方式，是否将手机号发送给对方? ", 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"height":"30px","padding":"0 24px"},
              disabled: !_ctx.custom.data && !_ctx.custom.description && _ctx.custom.extension,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, _toDisplayString(_ctx.$t('发送')), 9, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "mask",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
        }))
      : _createCommentVNode("", true)
  ]))
}